import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 13px;
  height: 13px;
`

const Beautify = ({ title = 'Code Tag', ...rest }: IconProps) => {
  return (
    <StyledIcon viewBox="0 0 16 16" title={title} {...rest}>
      <title>{title || 'Utility / Formatcode / 16px'}</title>
      <g id="Utility/Formatcode/16px" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="menu-7"
          transform="translate(8.000000, 8.035714) scale(-1, 1) translate(-8.000000, -8.035714) translate(1.500000, 2.000000)"
          fill="#2673cd"
          fillRule="nonzero"
        >
          <path
            d="M13,-0.785714286 C13.6903559,-0.785714286 14.25,-0.226070223 14.25,0.464285714 C14.25,1.15464165 13.6903559,1.71428571 13,1.71428571 L0,1.71428571 C-0.690355937,1.71428571 -1.25,1.15464165 -1.25,0.464285714 C-1.25,-0.226070223 -0.690355937,-0.785714286 0,-0.785714286 L13,-0.785714286 Z"
            id="Path"
          />
          <path
            d="M6.5,4.78571429 C7.19035594,4.78571429 7.75,5.34535835 7.75,6.03571429 C7.75,6.72607022 7.19035594,7.28571429 6.5,7.28571429 L0,7.28571429 C-0.690355937,7.28571429 -1.25,6.72607022 -1.25,6.03571429 C-1.25,5.34535835 -0.690355937,4.78571429 0,4.78571429 L6.5,4.78571429 Z"
            id="Path"
          />
          <path
            d="M13,10.3571429 C13.6903559,10.3571429 14.25,10.9167869 14.25,11.6071429 C14.25,12.2974988 13.6903559,12.8571429 13,12.8571429 L0,12.8571429 C-0.690355937,12.8571429 -1.25,12.2974988 -1.25,11.6071429 C-1.25,10.9167869 -0.690355937,10.3571429 0,10.3571429 L13,10.3571429 Z"
            id="Path"
          />
        </g>
      </g>
    </StyledIcon>
  )
}

Beautify.displayName = 'Beautify'
Beautify.needsWork = true
export default Beautify
